import { __decorate } from "tslib";
import Reportable from '../decorators/reportable';
class UICommon {
    static CURRENCY_SIGN = ''; //&#8381;
    static CURRENCY_POSTFIX = ' р.';
    static setCurrencySign(val) {
        if (typeof val === 'string') {
            this.CURRENCY_SIGN = val;
        }
    }
    static setCurrencyPostfix(val) {
        if (typeof val === 'string') {
            this.CURRENCY_POSTFIX = val;
        }
    }
    static formatPrice(price, emptyIfZero = true, omitMinor = true) {
        let inMinors = Math.round(Math.floor(price * 100)), major = Math.round(Math.floor(inMinors / 100)), minor = Math.round(inMinors % 100);
        if (emptyIfZero && major === 0 && minor === 0) {
            return '';
        }
        let inner = '';
        if (minor === 0 || omitMinor) {
            inner = `${major}`;
        }
        else {
            inner = `${major}.${minor}`;
        }
        return `${this.CURRENCY_SIGN}${inner}${this.CURRENCY_POSTFIX}`;
    }
    static updateStyle(el, map) {
        let style = el.style;
        for (let [key, val] of map) {
            style.setProperty(key, val);
        }
    }
    static findAndUpdateStyle(query, map, prefix = '') {
        let el = document.querySelector(prefix + ' ' + query);
        if (el) {
            UICommon.updateStyle(el, map);
        }
    }
    static findAllAndUpdateStyle(query, map, prefix = '') {
        let els = document.querySelectorAll(prefix + ' ' + query);
        if (els) {
            Array.from(els).forEach(el => UICommon.updateStyle(el, map));
        }
    }
    static convertBagetURL(url) {
        let parts = url.split('.');
        return `https://${window.location.host}/_ROLLUP_PATH_TO_BAGETS_${parts[0]}.webp`;
    }
    static rotateImageReturnDataURL(url, deg) {
        return new Promise((resolve, reject) => {
            try {
                let can = document.createElement('canvas'), img = new Image(), ctx = can.getContext('2d');
                img.onload = () => {
                    can.width = img.width;
                    can.height = img.height;
                    if (ctx) {
                        ctx.translate(img.width / 2, img.height / 2);
                        ctx.rotate(deg / 180 * Math.PI);
                        ctx.drawImage(img, -img.width / 2, -img.height / 2, img.width, img.height);
                    }
                    resolve(can.toDataURL());
                };
                img.crossOrigin = 'Anonymous';
                img.src = url;
            }
            catch (e) {
                reject(e);
            }
        });
    }
}
__decorate([
    Reportable
], UICommon, "formatPrice", null);
__decorate([
    Reportable
], UICommon, "updateStyle", null);
__decorate([
    Reportable
], UICommon, "findAndUpdateStyle", null);
__decorate([
    Reportable
], UICommon, "findAllAndUpdateStyle", null);
export default UICommon;
